var path = '/app/components/ui/stage-card/stage-card.html';
var html = "<a class=stage-card-wrap ng-click=$ctrl.goTo($ctrl.stage.route)> <div class=title> {{ $ctrl.title }} </div> <div class=circles> <i class=circle ng-class=\"{ 'complete': ( $ctrl.stage.totalCompleted > 0) }\"></i> <i class=circle ng-class=\"{ 'complete': ( $ctrl.stage.totalCompleted > 1 ) }\"></i> <i class=circle ng-class=\"{ 'complete': ( $ctrl.stage.totalCompleted > 2 ) }\"></i> </div> </a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/stage-card/stage-card.html
// module id = 158
// module chunks = 0